import { useState, useEffect } from 'react';
import CommonConfig from '../../utils/constant';
import SchoolProfile from './SchoolProfile';
import TeacherProfile from './TeacherProfile';
import StudentProfile from './StudentProfile';
import ParentProfile from './ParentProfile';

const EditProfile = (props) => {
    console.log
    ('CommonConfig.loginData().UserRole: ', CommonConfig.loginData().UserRole);
    return (
        <div className="e-teacher-dashboard">
            {CommonConfig.loginData().UserRole === 'School' ? <SchoolProfile /> : CommonConfig.loginData().UserRole === 'Teacher' ? <TeacherProfile /> : CommonConfig.loginData().UserRole === 'Student' ? <StudentProfile /> : <ParentProfile/>}
        </div>
    );
};

export default EditProfile;
